<template>
  <div id="add-form">
    <div
      id="container-login"
      class="container d-flex justify-content-center mt-4 align-items-center"
      style="height: 70vh"
    >
      <div class="card w-40 rounded-3 shadow-lg">
        <div class="card-header bg-light">
          <h5 class="card-title text-center">Add new task</h5>
        </div>
        <div class="card-body">
          <FormAdd @addData="addData"></FormAdd>
          <div class="mb-3 d-flex justify-content-center mt-1">
            <div class="g-signin2" data-onsuccess="onSignIn"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormAdd from "../components/FormAdd"
export default {
    name: "AddTask",
    components: {
        FormAdd
    },
    methods: {
      addData(data) {
        console.log(data, '<< data addTask.vue');
        this.$emit('addData', data)
      }
    }
};
</script>

<style>
</style>